import React from 'react';
import './SectionActions.scss';

const SectionActions = ({children}) => {
  return <div className='section__actions'>{children}</div>;
};

export default SectionActions;
